import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { CajaProvider } from '../context/CajaContext';

const HomePage = lazy(() => import('../pages/home/page'));
const BuscarMedicoPage = lazy(() => import('../pages/buscar-medico/page'));
const CitasMedicasPage = lazy(() => import('../pages/citas-medicas/page'));
const AdmisionesPage = lazy(() => import('../pages/admisiones/page'));
const HistoriaClinicaPage = lazy(() => import('../pages/historia-clinica/page'));
const ProcedimientosPage = lazy(() => import('../pages/procedimientos/page'));
const RegistroPage = lazy(() => import('../pages/auth/registro/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const PacienteDashboard = lazy(() => import('../pages/paciente/dashboard/page'));
const MedicoDashboard = lazy(() => import('../pages/medico/dashboard/page'));
const MedicoAgenda = lazy(() => import('../pages/medico/agenda/page'));
const MedicoCitas = lazy(() => import('../pages/medico/citas/page'));
const MedicoPacientes = lazy(() => import('../pages/medico/pacientes/page'));
const MedicoAtencion = lazy(() => import('../pages/medico/atencion/page'));
const MedicoEvolucion = lazy(() => import('../pages/medico/evolucion/page'));
const MedicoProcedimiento = lazy(() => import('../pages/medico/procedimiento/page'));
const MedicoMisHistorias = lazy(() => import('../pages/medico/mis-historias/page'));
const MedicoAtencionesPaciente = lazy(() => import('../pages/medico/mis-historias/AtencionesPacientePage'));
const MedicoPerfilPage = lazy(() => import('../pages/medico/perfil/page'));

const NotFound = lazy(() => import('../pages/NotFound'));

const MenuSecretaria = lazy(() => import('../pages/secretaria/dashboard/MenuSecretaria'));
const GestionCitasPage = lazy(() => import('../pages/secretaria/GestionCitasPage'));
const AgendasPage = lazy(() => import('../pages/secretaria/AgendasPage'));
const PacientesPage = lazy(() => import('../pages/secretaria/PacientesPage'));
const PacienteHistoricoPage = lazy(() => import('../pages/secretaria/historico/PacienteHistoricoPage'));
const PacienteVacunasPage = lazy(() => import('../pages/secretaria/vacunas/PacienteVacunasPage'));
const EditarPacientePage = lazy(() => import('../pages/secretaria/pacientes/EditarPacientePage'));
const PreFacturasPage = lazy(() => import('../pages/secretaria/facturacion/PreFacturasPage'));
const ViewPrefacturaContrato = lazy(() => import('../pages/secretaria/facturacion/ViewPrefacturaContrato'));
const MonitorDeFacturas = lazy(() => import('../pages/secretaria/facturacion/MonitorDeFacturas'));
const FacturaVista = lazy(() => import('../pages/secretaria/facturacion/FacturaVista'));
const ModuloFacturacion = lazy(() => import('../pages/secretaria/facturacion/ModuloFacturacion'));
const FacturaGlobalContrato = lazy(() => import('../pages/secretaria/facturacion/FacturaGlobalContrato'));
const FacturaDetalladaContrato = lazy(() => import('../pages/secretaria/facturacion/FacturaDetalladaContrato'));
const NotasCreditoList = lazy(() => import('../pages/secretaria/facturacion/NotasCreditoList'));
const NotaCreditoForm = lazy(() => import('../pages/secretaria/facturacion/NotaCreditoForm'));
const EntidadesPage = lazy(() => import('../pages/secretaria/entidades/EntidadesPage'));
const ContratosPage = lazy(() => import('../pages/secretaria/contratos/ContratosPage'));
const MedicoMenu = lazy(() => import('../pages/medico/layout/MedicoMenu'));
const CajaPage = lazy(() => import('../pages/secretaria/caja/CajaPage'));
const ResolucionesFacturacionPage = lazy(() => import('../pages/secretaria/facturacion/ResolucionesFacturacionPage'));
import * as PlaceholderViews from '../pages/secretaria/views/PlaceholderViews';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/buscar-medico',
    element: <BuscarMedicoPage />,
  },
  {
    path: '/citas-medicas',
    element: <CitasMedicasPage />,
  },
  {
    path: '/admisiones',
    element: <AdmisionesPage />,
  },
  {
    path: '/historia-clinica',
    element: <HistoriaClinicaPage />,
  },
  {
    path: '/procedimientos',
    element: <ProcedimientosPage />,
  },
  {
    path: '/registro',
    element: <RegistroPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/paciente/dashboard',
    element: <PacienteDashboard />,
  },
  /* {
    path: '/medico/dashboard',
    element: <MedicoDashboard />,
  }, */
  /* {
    path: '/monitor1',
    element: <MedicoDashboard />, 
  }, */
  {
    path: '/monitor2', // Secretaria Dashboard
    element: <CajaProvider><MenuSecretaria /></CajaProvider>,
    children: [
      {
        path: 'gestioncitas',
        element: <GestionCitasPage />
      },
      {
        path: 'citadospormes',
        element: <AgendasPage />
      },
      {
        path: 'listadopacientes',
        element: <PacientesPage />
      },
      {
        path: 'pacientes/:id/historico',
        element: <PacienteHistoricoPage />
      },
      {
        path: 'pacientes/:id/vacunas',
        element: <PacienteVacunasPage />
      },
      {
        path: 'pacientes/:id/editar',
        element: <EditarPacientePage />
      },
      {
        path: 'prefacturas',
        element: <PreFacturasPage />
      },
      {
        path: 'view-prefactura/:idPre',
        element: <ViewPrefacturaContrato />
      },
      {
        path: 'monitorfacturas',
        element: <MonitorDeFacturas />
      },
      {
        path: 'factura/:id',
        element: <FacturaVista />
      },
      {
        path: 'facturacion',
        element: <ModuloFacturacion />
      },
      {
        path: 'facturaentidades',
        element: <FacturaGlobalContrato />
      },
      {
        path: 'facturaentidadesdetallada',
        element: <FacturaDetalladaContrato />
      },
      {
        path: 'notascredito',
        element: <NotasCreditoList />
      },
      {
        path: 'notascredito/nueva',
        element: <NotaCreditoForm />
      },
      {
        path: 'notascredito/:id',
        element: <NotaCreditoForm />
      },
      {
        path: 'entidades',
        element: <EntidadesPage />
      },
      {
        path: 'contratos',
        element: <ContratosPage />
      },
      {
        path: 'caja',
        element: <CajaPage />
      },
      {
        path: 'resolucionesfacturacion',
        element: <ResolucionesFacturacionPage />
      },
    ]
  },
  // MEDICO ROUTES WRAPPED IN MENU
  {
    path: '/medico',
    element: <MedicoMenu />,
    children: [
      {
        path: 'dashboard',
        element: <MedicoDashboard />,
      },
      {
        path: 'agenda',
        element: <MedicoAgenda />,
      },
      {
        path: 'citas',
        element: <MedicoCitas />
      },
      {
        path: 'pacientes',
        element: <MedicoPacientes />
      },
      {
        path: 'atencion/:citaId',
        element: <MedicoAtencion />
      },
      {
        path: 'evolucion/:citaId',
        element: <MedicoEvolucion />
      },
      {
        path: 'procedimiento/:citaId',
        element: <MedicoProcedimiento />
      },
      {
        path: 'mis-historias',
        element: <MedicoMisHistorias />
      },
      {
        path: 'mis-historias/paciente/:idpaciente',
        element: <MedicoAtencionesPaciente />
      },
      {
        path: 'perfil',
        element: <MedicoPerfilPage />
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
